module.exports = __webpack_public_path__ + "static/media/ivc2.31e7536a.png";